import React from 'react'
import { PageErrorNoRouting } from '../../pages/PageError'

interface AppEnvironment {
    environment: string
    domain: string
    host: string
    instance: string
}

//get domain
const getDomain = () => {
    //get the scheme, domain and port
    const host = window.location.hostname
    const port = window.location.port
    const scheme = window.location.protocol
    const domain = `${scheme}//${host}${port ? ':' + port : ''}`
    return domain
}

//get the environment name
const getEnvironment = () => {
    const env = process.env.REACT_APP_ENV
    //if the first part of the subdomain ends in staging, return staging
    const domain = getDomain()
    const subdomain = domain.split('.')[0]
    if (subdomain.endsWith('staging')) {
        return 'staging'
    }
    return env
}

const environmentContext = React.createContext<AppEnvironment | undefined>(undefined)
const useEnvironmentContext = () => {
    const contextInstance = React.useContext(environmentContext)
    if (contextInstance === undefined) {
        throw new Error('useContext must be used within a ContextProvider')
    }
    return contextInstance
}
const AppEnvironmentProvider = (props: { children: React.ReactNode }) => {
    const ContextProvider = environmentContext.Provider
    //get the tenant id & environment
    let value = null
    let tenantID = null
    try {
        const environment = getEnvironment()
        const domain = getDomain()
        const instance = process.env.REACT_APP_INSTANCE || null
        const host = domain.split('//')[1].split('/')[0]
        value = { environment, domain, host, instance } as AppEnvironment
    } catch (e) {
        console.error('Error getting tenant ID or environment', e)
        return <PageErrorNoRouting error={'A configuration error occurred - please contact support'} />
    }
    return <ContextProvider value={value}>{props.children}</ContextProvider>
}

export { AppEnvironmentProvider as default, useEnvironmentContext, type AppEnvironment }

